<template>
  <div class="container">
    <div id="login-overlay" class="modal-dialog" style="max-width: 500px">
      <div class="modal-content">
        <div
          class="modal-header text-center"
          style="padding-top: 0px !important; padding-bottom: 0px !important"
        >
          <h2><i class="fa fa-support"></i> Contact Support</h2>
        </div>

        <div class="modal-body">
          <div class="row">
            <div v-if="!checkUser" class="col-xs-12 col-sm-12">
              <div class="well" style="margin-bottom: 5px">
                <div>
                  <h3>
                    You have to be logged in to create a customer support ticket
                  </h3>
                </div>
              </div>
              <br />
              <button class="btn btn-success btn-block" @click="goLogin">
                Login
              </button>
              <button class="btn btn-info btn-block" @click="goHome">
                Home
              </button>
            </div>
            <!-- end of !checkUser-->
            <div v-if="checkUser" class="col-xs-12 col-sm-12">
              <div class="well" style="margin-bottom: 5px; min-height: 200px">
                <div v-if="pending == true">
                  <p>
                    Name: <strong>{{ compUserName }}</strong>
                  </p>

                  <p v-if="compBookingId">
                    <span><input v-model="related" type="checkbox" /></span>
                    Issue is related to
                    <strong>Booking No: {{ compBookingId }}</strong>
                  </p>

                  <p>Describe your problem below:</p>
                  <div class="form-group">
                    <textarea
                      class="form-control"
                      name="description"
                      rows="3"
                      v-model="ticket.Description"
                      v-validate="'required|min:8'"
                      :class="{
                        input: true,
                        'has-error': errors.has('description'),
                      }"
                      placeholder="please describe your problem here"
                      data-vv-delay="1000"
                      id="supportTextArea"
                    ></textarea>
                    <span
                      v-show="errors.has('description')"
                      class="text-danger h5"
                      >{{ errors.first("description") }}</span
                    >
                  </div>
                </div>
                <div v-if="sent == true">
                  <div class="alert alert-danger" v-if="errorMsg">
                    <p>{{ errorMsg }}</p>
                  </div>
                  <div class="alert alert-success" v-if="alertMsg">
                    <p>{{ alertMsg }}</p>
                  </div>
                </div>
                <button
                  :disabled="errors.has('description') || !ticket.Description"
                  class="btn btn-success btn-block"
                  v-if="!sent"
                  @click="createTicket()"
                >
                  Create Ticket
                </button>
                <button
                  class="btn btn-success btn-block"
                  v-if="sent"
                  :disabled="sent"
                  @click="createTicket()"
                >
                  Ticket Sent Successfully
                </button>
              </div>

              <hr />
              <button class="btn btn-info btn-block" @click="goHome()">
                Go Home
              </button>
            </div>
            <!-- end of checkUser-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const API_URL = "https://www.dupaws.com/services/";
import auth from "../../auth/index";
import store from "../../data/store";

export default {
  name: "contactSupport",
  data() {
    return {
      userRequest: "",
      pending: true,
      errorMsg: "",
      alertMsg: "",
      sent: false,
      scrollPosition: "",
      ticket: {
        BookingNo: "",
        Description: "",
      },
      related: true,
    };
  },
  updated() {
    var self = this;
    //    $zopim(function (){
    //       $zopim.livechat.sendVisitorPath();
    //   });

    $("#supportTextArea").focus(function () {
      self.scrollPosition = window.scrollY;
    });
    $("#supportTextArea").blur(function () {
      // $(window).animate({ scrollTop: this.scrollPosition }, "slow");
      self.$SmoothScroll(self.scrollPosition, 350);
    });
  },
  methods: {
    goLogin() {
      this.$router.push({ path: "/login" });
    },
    goHome() {
      this.$router.push({ path: "/" });
    },
    createTicket() {
      var self = this;
      if (self.compBookingId != null && self.related == true)
        self.ticket.BookingNo = self.compBookingId;
      $.ajax({
        type: "POST",
        url: API_URL + "api/createTicket",
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "Authorization",
            "bearer " + localStorage.getItem("access_token")
          );
        },
        data: JSON.stringify(self.ticket),
        crossDomain: true,
        contentType: "application/json; charset=utf-8",
        success: function (data) {
          self.ticket = data;
          if (self.ticket.TicketNo != null) {
            self.alertMsg = `Thank you, your Ticket No ${self.ticket.TicketNo} has been successfuly created, we will get back to you shortly`;
            self.errorMsg = "";
            self.sent = true;
            self.pending = false;
          }
        },
        error: function (data, status, error) {
          self.sent = true;
          self.pending = false;
          self.errorMsg = data.responseText;
          self.alertMsg = "";
          console.log("couldn't create ticket" + data.responseText);
        },
      });
    },
  },
  mounted: function () {},
  computed: {
    checkUser: function () {
      return store.getters.authenticated;
    },
    compUserName: function () {
      if (store.getters.firstName && store.getters.lastName)
        return store.getters.firstName + " " + store.getters.lastName;
      else if (
        localStorage.getItem("firstName") != null &&
        localStorage.getItem("lastName") != null
      )
        return (
          localStorage.getItem("firstName") +
          " " +
          localStorage.getItem("lastName")
        );
      else return "Guest";
    },
    compUserRole: function () {
      return store.getters.userRole;
    },
    compEmail: function () {
      return store.getters.email;
    },
    compBookingId: function () {
      if (this.$route.query) {
        return this.$route.query.bookingId;
      }
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// ContactSupport.vue?b94938c2